const MILESTONE_DETAILS = "/admin/work-milestones"

const apiUrl = {
    MILESTONE_DETAILS,
};

export default apiUrl;